import React, { useState, useEffect, useRef} from 'react';
import { v4 as uuidv4 } from 'uuid'
import "./Compare.scss"
const Compare = (props) => {
  const container = useRef(null);

  useEffect(() => {
    if(container?.current?.offsetHeight && props.data.field_label === "Intervention") {
      let height = container.current.offsetHeight;
      props.api.forEachNode((rowNode, i) => {
        if(rowNode.rowIndex === props.node.rowIndex) {
          rowNode.setRowHeight(height)
          props.api.onRowHeightChanged()
        }
      })
    }
  }, [container])

  const getFormatInterventions = (interventions) => {

    return interventions.map((int, i) => {
      const {name,type,other_intervention_names,description} = int;
      let interventionValueToShow = other_intervention_names;
      if(interventionValueToShow ) {
        const namesArray = Array.isArray(other_intervention_names)
          ? other_intervention_names
          : [other_intervention_names];       //in prime other_intervention_names is an array but sometimes in prs its a string, converting it to an array if its a string for better comparison
     
          if(namesArray.length>0) {
            interventionValueToShow = (
              <div className='intervention-description-and-other-names'>
                Other Names: {namesArray.join(', ')}
              </div>
            );
          }
    
      }

      return (
        <div key={uuidv4()} className='registry-interventions'>
          <div className='intervention-title'>{`${name}: ${type}`}</div>
          <div className='intervention-description-and-other-names'>{description}</div>
           {interventionValueToShow} 
        </div>
      )
    })
  }

  const displayValue = () => {
    if(typeof props.value === 'object' && props.value !== null) {
      if(props.data.field_label === "Intervention") {
        return (
          <div className='registery-in-container'>
            {getFormatInterventions(props.value)}
          </div>
        )
      }
    } else {
      return props.value
    }
  }

  return (
    <div ref={container} className='compare-registery-container'>
      {displayValue()}
    </div>
  );
};

export default Compare;






